export const CONNECTION_TYPE = {
  EXECUTIVE: "executive",
  BOTH: "both",
  BOARD_MEMBER: "board_member",
  NONE: "none",
};

export const ENTITY_PATHS = {
  company: "companies",
  private_company: "private_companies",
  government: "governments",
  other_government: "other_governments",
  superannuation: "superannuations",
  nfp: "nfps",
};

export const CONSOLIDATE_CONNECTIONS_TAB_NAMES = {
  CONNECTION_LIST: "connection_list",
  LINK_WITH_OTHERS: "link_with_others",
  CONNECTION_HISTORY: "connection_history",
};
